import type { FormValidationError } from '../../../FormValidator';
import type { Action } from '../../../../../types/context-action/action';

export const BASE_FIELD_ACTIONS = {
  DATE_FIELD_ON_CHANGE: 'DATE_FIELD_ON_CHANGE',
  NUMBER_FIELD_ON_CHANGE: 'NUMBER_FIELD_ON_CHANGE',
  TEXT_FIELD_ON_CHANGE: 'TEXT_FIELD_ON_CHANGE',
  LIST_FIELD_ON_CHANGE: 'LIST_FIELD_ON_CHANGE',
  SELECT_FIELD_ON_CHANGE: 'SELECT_FIELD_ON_CHANGE',
  TAXONOMY_FIELD_ON_CHANGE: 'TAXONOMY_FIELD_ON_CHANGE',
} as const;

export type DateFieldOnChangeAction = Action<
  typeof BASE_FIELD_ACTIONS.DATE_FIELD_ON_CHANGE,
  {
    id: string;
    newValue: string;
    errorId?: FormValidationError;
  }
>;

export type NumberFieldOnChangeAction = Action<
  typeof BASE_FIELD_ACTIONS.NUMBER_FIELD_ON_CHANGE,
  {
    id: string;
    newValue: string;
    errorId?: FormValidationError;
  }
>;

export type TextFieldOnChangeAction = Action<
  typeof BASE_FIELD_ACTIONS.TEXT_FIELD_ON_CHANGE,
  {
    id: string;
    newValue: string;
    errorId?: FormValidationError;
  }
>;

export type ListFieldOnChangeAction = Action<
  typeof BASE_FIELD_ACTIONS.LIST_FIELD_ON_CHANGE,
  {
    id: string;
    newValues: Array<string>;
    errorId?: FormValidationError;
  }
>;

export type SelectFieldOnChangeAction = Action<
  typeof BASE_FIELD_ACTIONS.SELECT_FIELD_ON_CHANGE,
  {
    id: string;
    newValues: Array<string>;
    errorId?: FormValidationError;
  }
>;

export type TaxonomyFieldOnChangeAction = Action<
  typeof BASE_FIELD_ACTIONS.TAXONOMY_FIELD_ON_CHANGE,
  {
    id: string;
    newValues: Array<string>;
    errorId?: FormValidationError;
  }
>;

export type BaseFieldAction =
  | DateFieldOnChangeAction
  | NumberFieldOnChangeAction
  | TextFieldOnChangeAction
  | ListFieldOnChangeAction
  | SelectFieldOnChangeAction
  | TaxonomyFieldOnChangeAction;
